export const Screen = {
  // width: 2480,
  // height: 3508,
  width: window.innerWidth,
  height: window.innerHeight,
};
